import { combineReducers } from 'redux'
import app from './app'
import selected from './selected'
import { appTypes } from '../actions/types'

const reducers = combineReducers({
  app,
  selected,
})

export default (state, action) => {
  if (action.type === appTypes.backToState) return action.state
  return reducers(state, action)
}
